module.exports = __webpack_public_path__ + "static/img/7-3.0a9f561.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/case/7-3.png
// module id = 88mn
// module chunks = 0